import { get, postj } from '@/utils/request';

export const packageType = (param) => get('order/packageType',param); // 获取打托类型
export const platform = (param) => get('users/platform',param); // 获取打托类型